import { NotItems } from "component/basic/notItems";
import { carCode, comFormat, setDateTime } from "js/function";
import { Fragment, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { CarDetailAnnouncementBox, CarDetailAnnouncementTextBox, CarDetailOptionBox, CarDetailOptionItem, CarDetailSection, SubAccordionBox, SubAccordionItem } from "./page";
import { BtnItem } from "component/basic/btns";

function CarLabelItem(data){
    return (
        <p className={`carLabelItem ${data.addClass||""}`} dangerouslySetInnerHTML={{__html:data.text}}/>//gColor yColor bColor rColor
    );
}

function CarLabelBox(data){
    return (
        <div className={`carLabelBox ${data.addClass||""}`}>
            {data?.data && data?.data?.map((item,i)=>(
                <Fragment key={i}>
                    {item.text ? 
                        <CarLabelItem
                            addClass={item.type}
                            text={item.text}
                        />
                    :""}
                </Fragment>
            ))}
        </div>
    );
}

function CarImg(data){
    return (
        <div className={`carImg backgroundImg ${data.addClass||""}`} style={{backgroundImage:`url('${data.img}')`}}/>
    );
}

function CarNameBox(data){
    return (
        <div className={`carNameBox ${data.addClass||""}`}>
            <p className="carMaker" dangerouslySetInnerHTML={{__html:data.carMaker}}/>
            <p className="carName" dangerouslySetInnerHTML={{__html:data.carName}}/>
        </div>
    );
}

function CompanyNameBox(data){
    return (
        <div className={`carNameBox ${data.addClass||""}`}>
            <p className="companyName" dangerouslySetInnerHTML={{__html:data.companyName}}/>
        </div>
    );
}

function CarMainInfoItem(data){
    return (
        <div className={`carMainInfoItem ${data.addClass||""}`}>
            <img src={`/assets/images/icon/${data.icon}.svg`}/>
            <p className="carMainInfoItem_text" dangerouslySetInnerHTML={{__html:data.text}}/>
        </div>
    );
}

function CarMainInfoBox(data){
    return (
        <div className={`carMainInfoBox ${data.addClass||""}`}>
            {data.count ? 
                <CarMainInfoItem
                    icon="car_item_count"
                    text={data.count}
                />
            :""}
            {data.type ? 
                <CarMainInfoItem
                    icon="car_item_type"
                    text={data.type}
                />
            :""}
            {data.min_year || data.max_year ? 
                <CarMainInfoItem
                    icon={data.yearType2 ? "car_item_year2" : "car_item_year"}
                    text={data.min_year === data.max_year ? data.max_year : `${data.min_year||""}${data.min_year && data.max_year ? "~" : ""}${data.max_year||""}`}
                />
            :""}
        </div>
    );
}

function CarDetailSubInfoItem(data){
    return (
        <div className={`carDetailSubInfoItem ${data.addClass||""}`}>
            <h3 className="carDetailSubInfoItem_text" dangerouslySetInnerHTML={{__html:data.text}}/>
            <p className="carDetailSubInfoItem_name" dangerouslySetInnerHTML={{__html:data.name}}/>
        </div>
    );
}

function CarDetailSubInfoBox(data){
    return (
        <div className={`carDetailSubInfoBox ${data.addClass||""}`}>
            {data.count ? 
                <CarDetailSubInfoItem
                    name="탑승인원"
                    text={data.count}
                />
            :""}
            {data.min_year || data.max_year ? 
                <CarDetailSubInfoItem
                    name={"차량연식"}
                    text={data.min_year === data.max_year ? data.max_year : `${data.min_year||""}${data.min_year && data.max_year ? "~" : ""}${data.max_year||""}`}
                />
            :""}
            {data.type ? 
                <CarDetailSubInfoItem
                    name="연료"
                    text={data.type}
                />
            :""}
        </div>
    );
}

function CarSubPriceBox(data){

    return (
        <div className="carSubPriceBox">
            <p className="carSubPrice_caption" dangerouslySetInnerHTML={{__html:data.text}}/>
            <h2 className="carSubPrice wbTextColor">{comFormat((data.price ? data.price : data.discount_price ? data.discount_price : data.original_price)||0)}원</h2>
        </div>
    );
};

function CarSlideItem(data){
    let navigate = useNavigate();

    return (
        <button type="button" onClick={()=>{data.func(data.modelName, data.insurance_id)}} className={`carSlideItem ${data.addClass||""}`}>
            <CarLabelBox
                addClass="between"
                data={[
                    {
                        type:"gColor",
                        text:data.carCategory
                    },
                    {
                        type:null,
                        text:data.type ? "가장 높은 예약률" : data.eventRate ? `${data.eventRate}% 할인` : null
                    }
                ]}
            />
            <CarImg 
                img={data.car_image}//이미지 없음 
            />
            <CarNameBox
                carMaker={data.maker}
                carName={data.modelName}
            />
            <CarMainInfoBox
                count={`${data.passengerNum||0}인승`}
                type={data.fuelType}
                min_year={data.min_year}
                max_year={data.max_year}
            />
            <CarSubPriceBox
                text={"내일 출발<br/><span>24시간 대여 기준</span>"}
                price={data.price}
            />
        </button>
    );
}

function CarSlideControll(data){
    const sliderRef = data.swiperRef;

    return (
        <div className="carSlideControll">
            <div className="carSlideControllBox">
                <button className="swiper-button-prev" onClick={() => sliderRef?.current?.swiper.slidePrev()}/>
                <button className="swiper-button-next" onClick={() => sliderRef?.current?.swiper.slideNext()}/>
            </div>
        </div>
    );
};

function CarSlideBox(data){
    const [pageCount,setPageCount] = useState("01");
    const swiperRef = useRef(null);

    return (
        <div className={`carSlideBox ${data.addClass||""}`}>
            <div className="carSlide_titleArea">
                <div className="carSlide_titleBox">
                    <p className="carSlide_title" dangerouslySetInnerHTML={{__html:data.title}}/>
                    <p className="carSlide_subTitle" dangerouslySetInnerHTML={{__html:data.subTitle}}/>
                </div>
                {data.data && data.data?.length > 3 ?
                <div className="carSlide_pageBox">
                    <p className="carSlide_page wbTextColor">{pageCount}</p>
                    <p className="carSlide_page">{data.data?.length ? data.data?.length < 10 ? `0${data.data?.length}` : data.data?.length : "00"}</p>
                </div>
                :""}
            </div>
            <div className={`carSlide ${data.addClass||""} ${data.data && data.data?.length > 0 ? "" : "carSlide_notItem"}`}>
                {data.data && data.data?.length > 0 ? 
                    <div className="carSlideItemBox">
                    <Swiper
                        spaceBetween={20}
                        slidesPerView={3}
                        autoHeight={false}
                        loop={true}
                        breakpoints={{
                            960: {
                            slidesPerView: 3
                            },
                            1: {
                                slidesPerView: 1
                            }
                        }}
                        onRealIndexChange={(e) => {
                            setPageCount(e.realIndex + 1 < 10 ? `0${e.realIndex + 1}` : e.realIndex + 1);
                        }}
                        ref={swiperRef}
                    >
                        {data.data && data.data?.map((item, i) => (
                            <SwiperSlide key={i}>
                                <CarSlideItem
                                    id={item?.id}
                                    type={data.type === "popularCar" && i == 0 ? true : false}
                                    carCategory={item?.type}
                                    eventRate={item?.specialEventRate}
                                    car_image={item?.image_url}
                                    maker={item?.maker}
                                    modelName={item?.name}
                                    passengerNum={item?.passenger_number}
                                    fuelType={item?.fuel}
                                    min_year={item?.min_year}
                                    max_year={item?.max_year}
                                    insurance_id={item?.insurance_id}
                                    price={(item?.discount_price ? item?.discount_price : item?.price)||"0"}
                                    func={(name, insuranceId)=>{data.func(name, insuranceId)}}
                                />
                            </SwiperSlide>
                        ))}
                    </Swiper>
                    <CarSlideControll swiperRef={swiperRef}/>
                    </div>
                    :
                    <NotItems addClass="sectionMinNotItem" text={data.notListText}/>
                }
            </div>
        </div>
    );
}

function CarOptionBox(data){
    return (
        <div className="carOptionBox">
            {data.data?.map((item,i)=>(
                <div className={`carOptionItem ${item.is_chk == 1 ? "active" : ""}`} key={i} dangerouslySetInnerHTML={{__html:item.text}}/>
            ))}
        </div>
    );
};

function CarReservationTextItem(data){

    return (
        <div className={`carReservationTextItem ${data.addClass||""}`}>
            <p className="carReservationText_name" dangerouslySetInnerHTML={{__html:data.name}}/>
            <p className={`carReservationText_text ${data.addClass === "upSize" ? "wbTextColor" : ""}`} dangerouslySetInnerHTML={{__html:data.text}}/>
        </div>
    );
};

function CarReservationTextBox(data){

    return (
        <div className="carReservationTextBox">
            {data.children}
        </div>
    );
};

function CarReservationTextArea(data){

    return (
        <div className="carReservationTextArea">
            {data.children}
        </div>
    );
};

function CarReservationTextSection(data){

    return (
        <div className="carReservationTextSection">
            {data.children}
        </div>
    );
};

function CarListItem(data){
    let navigate = useNavigate();

    return (
        <button type="button" onClick={()=>{
                if(data.func){
                    data.func()
                }else if(data.type === "rent"){
                    navigate(`/rent/detail/${data.id}/${data.companyMappedCode}/${data.modelMappedCode}`,{state: data.stateData})
                }else{
                    navigate(`/reservation/detail/${data.id}`)
                }
            }} className={`carListItem ${data.addClass||""}`}>
            <div className="carListItem_carInfoArea">
                <CarImg 
                    img={data.car_image}
                />
                <div className="carListItem_carInfoBox">
                    <div className={"carRentDetailTextArea"}>
                        <CarLabelBox
                            addClass=""
                            data={data.type === "rent" ? [
                                    {
                                        type:"gColor",
                                        text:data.carCategory
                                    },
                                    {
                                        type:null,
                                        text:data.eventRate ? `${data.eventRate}% 할인` : null
                                    }
                                ]
                                :
                                [
                                    {
                                        type:data.reservation_cancel_request === 1 ? "rColor" : (carCode("reservationLabelColor",data.status)||null),
                                        text:data.reservation_cancel_request === 1 ? "예약 취소" : carCode("reservation",data.status)
                                    }
                                ]
                            }
                        />
                        {data.type === "rent" && (
                            <>
                                <CarLabelBox
                                    addClass=""
                                    data={[
                                        {
                                            type:data.is_outsourcing === 1 ? "gColor" : "bColor",
                                            text:data.is_outsourcing === 1 ? "제휴 렌터카사" : "AMANO 렌터카허브"
                                        }
                                    ]}
                                />
                            </>
                        )}

                    </div>
                    {data.mImgChk ? 
                    <CarImg 
                        addClass="mItem"
                        img={data.car_image}
                    />
                    :""}
                    <CarNameBox
                        carMaker={data.maker}
                        carName={data.modelName}
                    />
                    <CarMainInfoBox
                        count={`${data.passengerNum||0}인승`}
                        type={data.fuelType}
                        min_year={data?.min_year}
                        max_year={data?.max_year}
                    />
                    <CarOptionBox
                        data={data?.carOptions}
                    />
                    {data.type === "rent" ? 
                        <CarSubPriceBox
                            text={`차량 대여요금${data?.insuranceName ? `<br/><span>(${data?.insuranceName} 자차보험 포함)</span>` : ""}`}
                            discount_price={data.discount_price}
                            original_price={data.original_price}
                        />
                    :""} 
                </div>
            </div>
            {data.type === "reservation" ? 
                <CarReservationTextSection>
                    <CarReservationTextArea>
                            <CarReservationTextBox>
                                <CarReservationTextItem
                                    addClass=""
                                    name={"예약번호"}
                                    text={data?.reservationId||"-"}
                                />
                                <CarReservationTextItem
                                    addClass=""
                                    name={"보험정보"}
                                    text={data?.insuranceName||"-"}
                                />
                            </CarReservationTextBox>
                            <CarReservationTextBox>
                            <CarReservationTextItem
                                addClass=""
                                name={"대여일시"}
                                text={data?.startDtm ? setDateTime(data?.startDtm,"dayyyMinmmddhh",null) : "-"}
                            />
                            <CarReservationTextItem
                                addClass=""
                                name={"반납일시"}
                                text={data?.endDtm ? setDateTime(data?.endDtm,"dayyyMinmmddhh",null) : "-"}
                            />
                        </CarReservationTextBox>
                    </CarReservationTextArea>
                    <CarReservationTextItem
                        addClass="upSize"
                        name={"총 결제 금액"}
                        text={`${data?.payment_price ? comFormat(data?.payment_price) : "0"}원`}
                    />
                </CarReservationTextSection>
            :""}
        </button>
    );
}

function CarDetailItem(data){

    return (
        <CarDetailSection
            title={data.sectionTitle||null}
            titleSubItem={data.sectionTitleSubItem||null}
            captions={data.sectionCaptions||null}
            titleAddClass={data.titleAddClass}
        >  
            {data?.status ? 
                <CarLabelBox
                    addClass="between"
                    data={
                        [
                            {
                                type:data?.reservation_cancel_request === 1 ? "rColor" : (carCode("reservationLabelColor",data?.status)||null),
                                text:data?.reservation_cancel_request === 1 ? "예약 취소" : carCode("reservation",data?.status)
                            }
                        ]
                    }
                />
            :""}
            <div className="carDetail_carInfoBox">
                <div className="carDetail_carInfo">
                    <CarImg
                        addClass="mItemT"
                        img={data?.car_image}//이미지 없음 
                    />
                    <CarNameBox
                        carMaker={data?.maker}//제조사 코드 정의 없음
                        carName={data?.modelName}
                    />
                    <CarMainInfoBox
                        count={`${data?.passengerNum||0}인승`}
                        type={data.fuelType}
                        min_year={data?.min_year}
                        max_year={data?.max_year}
                    />
                </div>
                <CarImg
                    addClass="pcItemT"
                    img={data?.car_image}//이미지 없음 
                />
            </div>                    
            <SubAccordionBox>
                {data?.car_option && data?.car_option?.length > 0 ? 
                <SubAccordionItem title="포함된 옵션">
                    <CarDetailOptionBox>
                        {data?.car_option && data?.car_option?.map((item,i)=>(
                            <CarDetailOptionItem
                                key={i}
                                active={true}
                                text={item}
                            />
                        ))}
                    </CarDetailOptionBox>
                </SubAccordionItem>
                :""}
                {data?.carOptionDisable && data?.carOptionDisable?.length > 0 ? 
                <SubAccordionItem title="포함되지 않은 옵션" addClass="gColor">
                    <CarDetailOptionBox>
                        {data?.carOptionDisable && data?.carOptionDisable?.map((item,i)=>(
                            <CarDetailOptionItem
                                key={i}
                                active={false}
                                text={item?.name}
                            />
                        ))}
                    </CarDetailOptionBox>
                </SubAccordionItem>
                :""}
            </SubAccordionBox>
            {data.itemType === "edit" ? 
            <>
                <CarDetailAnnouncementBox
                    addClass="carInfoAnnouncementBox"
                    boxTitle={null}
                    title={null}
                    subTitle={null}
                >
                    <CarDetailAnnouncementTextBox
                        name="자차 보험"
                        text={`<b>${data.insurance_name||"-"}</b>`}
                    />
                </CarDetailAnnouncementBox>
                {data.func ? 
                <BtnItem
                    addClass="subColor carEditBtn"
                    contents={"차량(자차보험 포함) 변경"}
                    func={() => {
                        data.func();
                    }}
                />
                :""}
            </>
            :""}
        </CarDetailSection>
    );
};

function CarRentDetailItem(data){
    return (
        <CarDetailSection
            title={null}
            captions={data.sectionCaptions||null}
        >
            <div className={"carRentDetailTextArea"}>
                <div className="carRentDetailTextInfo">
                    <CarNameBox
                        carMaker={data?.maker}//제조사 코드 정의 없음
                        carName={data?.modelName}
                    />
                    <CarLabelBox
                        addClass=""
                        data={
                            [
                                {
                                    type: "gColor",
                                    text: data.carCategory
                                },
                                {
                                    type: null,
                                    text: data.eventRate ? `${data.eventRate}% 할인` : null
                                }
                            ]
                        }
                    />
                </div>
                <div>
                    <CompanyNameBox
                        companyName={data?.isOutsourcing === 0 ? "AMANO 렌터카허브" : data?.companyName}
                    />
                </div>
            </div>
            <div className="carRentDetailInfo">
                <CarImg
                    addClass=""
                    img={data?.car_image}//이미지 없음 
                />
                <CarDetailSubInfoBox
                    count={`${data?.passengerNum || 0}인승`}
                    type={data.fuelType}
                    min_year={data?.min_year}
                    max_year={data?.max_year}
                />
            </div>
        </CarDetailSection>
    );
};

export {
    CarLabelBox,
    CarImg,
    CarNameBox,
    CarMainInfoBox,
    CarSlideItem,
    CarSlideBox,
    CarOptionBox,
    CarListItem,
    CarDetailItem,
    CarRentDetailItem
};